import {
  STORE_CASHBOX_FILTERS,
  CLEAR_CASHBOX_FILTERS,
} from '@/store/actions/cashboxFilters';
import { AUTH_LOGOUT } from '@/store/actions/auth';

const CASHBOX_FILTERS_KEY = 'CASHBOX_FILTERS';

const actions = {
  [STORE_CASHBOX_FILTERS]: ({ commit }, filters) => {
    localStorage.setItem(CASHBOX_FILTERS_KEY, JSON.stringify(filters));
    commit(STORE_CASHBOX_FILTERS, filters);
  },
  [CLEAR_CASHBOX_FILTERS]: ({ commit }) => {
    localStorage.removeItem(CASHBOX_FILTERS_KEY);
    commit(CLEAR_CASHBOX_FILTERS);
  },
};

const getters = {
  isNeedConfirmCashboxFilters: (state) => state.filters !== null,
  getCashboxFilters: (state) => state.filters,
};

const mutations = {
  [STORE_CASHBOX_FILTERS]: (state, filters) => {
    state.filters = filters;
  },
  [AUTH_LOGOUT]: (state) => {
    state.filters = null;
  },
};

const state = () => ({
  filters: null,
});

export default () => ({
  actions,
  getters,
  mutations,
  state,
});
